const breederDamSireListFilters = {
    state: {
      filters: {}
    },
    mutations: {
      // Mutation to set a filter based on the label
      setBreederDamSireListFilters(state, { label, value }) {
        state.filters[label] = value;
      },
      resetBreederDamSireListFilters(state) {
        state.filters = {};
      }
    },
    actions: {
      // Action to apply a filter
      applyBreederDamSireListFilters({ commit }, { label, value }) {
        commit('setBreederDamSireListFilters', { label, value });
      },
      resetBreederDamSireListFilters({ commit }) {
        commit('resetBreederDamSireListFilters');
      }
    },
    getters: {
      getBreederDamSireListFilters: (state) => (label) => {
        return state.filters[label] || null;
      }
    }
  };
  
  export default breederDamSireListFilters;
  